import imageToBase64 from 'helpers/imageToBase64';
import { DataExporter, makeFilename } from '.';
import { WEB_LOGO } from 'constants.js.erb';

export default async function pdf(exporter: DataExporter) {
  const data = exporter();

  const jsPDF = require('jspdf');
  require('jspdf-autotable');

  const pdf = new jsPDF.jsPDF();
  await imageToBase64(WEB_LOGO)
    .then(image => {
      pdf.addImage(image, 'PNG', pdf.internal.pageSize.getWidth() - 65, 10, 50, 10);
    })
    .catch(error => {
      console.error(error);
    });
  pdf.setFontSize(14);
  pdf.text(data.title, 14, 30);
  pdf.text(data.subTitle, 14, 37);
  data.tables.forEach(table => {
    if (table.title) pdf.text(table.title, 14, (pdf.autoTable.previous.finalY || 37) + 10);
    pdf.autoTable({
      headStyles: { fillColor: [217, 217, 217], textColor: [128, 128, 128] },
      theme: 'grid',
      startY: pdf.autoTable.previous.finalY + (table.title ? 15 : 10) || (table.title ? 55 : 45),
      head: [table.header],
      body: table.body
    });
  });

  pdf.save(`${makeFilename(data)}.pdf`);
}
